import React from 'react';

import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import messages from './IncompleteCreditCheckError.messages';
import InternalLink from '../../../../components/InternalLink';
import { AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP } from '../../AutomatedLendingDecision.actions';

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
    goToStepTwo: () =>
        dispatch({
            type: AUTOMATED_LENDING_DECISION_CHANGE_APPLICATION_STEP,
            step: 'personalInformation'
        })
});

class IncompleteCreditCheckError extends React.Component {
    renderTitle = () => {
        return (
            <div className="title-text">
                <FormattedMessage {...messages.title} />
            </div>
        );
    };

    renderMessage = () => {
        const messageCheckDetailsLink = this.renderMessageCheckDetailsLink();

        return (
            <div
                className={classNames('content-text', {
                    'context-text-with-bullets': this.props.isIntroducer
                })}
                data-testid="error-details-text">
                <FormattedMessage
                    {...messages.message}
                    values={{ messageCheckDetailsLink }}
                />
            </div>
        );
    };

    renderMessageCheckDetailsLink = () => {
        const { goToStepTwo } = this.props;

        return (
            <InternalLink onClick={goToStepTwo}>
                <FormattedMessage {...messages.messageCheckDetailsLink} />
            </InternalLink>
        );
    };

    renderBullets = () => {
        return (
            <ul data-testid="bullet-points">
                <li>
                    <FormattedMessage {...messages.name} />
                </li>
                <li>
                    <FormattedMessage {...messages.address} />
                </li>
                <li>
                    <FormattedMessage {...messages.dob} />
                </li>
            </ul>
        );
    };

    renderTryAgainMessage = () => {
        return (
            <div className="secondary-text">
                <FormattedMessage {...messages.tryAgainMessage} />
            </div>
        );
    };

    render() {
        const isIntroducer = this.props.isIntroducer;
        const title = this.renderTitle();
        const message = this.renderMessage();
        const bullets = this.renderBullets();
        const tryAgain = this.renderTryAgainMessage();

        return (
            <div>
                {title}
                {message}
                {isIntroducer && (
                    <div className="bullet-messaging">
                        {bullets}
                        {tryAgain}
                    </div>
                )}
            </div>
        );
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IncompleteCreditCheckError);
